(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audit-log', {
            parent: 'admin',
            url: '/audit-log?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'auditLog.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/audit-log/audit-log.html',
                    controller: 'AuditLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort:{
                    squash:true
                },
                toDate: {
                    value:
                        (function today(){
                            return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
                        }),
                    squash: true
                },
                fromDate: {
                    value:
                        (function previousMonth(){
                            var fromDate = new Date();
                            if (fromDate.getMonth() === 0) {
                                return new Date(fromDate.getFullYear()-1, 11, fromDate.getMonth());
                            } else {
                                return new Date(fromDate.getFullYear(), fromDate.getMonth()-1, fromDate.getDate());
                            }
                        }),
                    squash: true
                },
                filter: {
                    value: {activity: ''},
                    squash: true
                },
                predicates :{},
                search:{
                    value:'',
                    squash:true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return{
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        search: $stateParams.search,
                        predicates : $stateParams.predicates,
                        toDate: $stateParams.toDate,
                        fromDate: $stateParams.fromDate,
                        filter: $stateParams.filter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('auditLog');
                    return $translate.refresh();
                }]
            }
        }).state('audit-log-detail', {
            parent: 'audit-log',
            url: '/audit-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'auditLog.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/audit-log/audit-log-detail.html',
                    controller: 'AuditLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('auditLog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AuditLogService', function ($stateParams, AuditLogService) {
                    return AuditLogService.get({id: $stateParams.id}).$promise;
                }]
            }
        });
    }
})();
